import PrintInvoices from "./PrintInvoices";

const openAndPrintHtml = async (html, windowName, features) => {
  const printWindow = window.open("", windowName, features);

  if (!printWindow) {
    alert("⚠️ المتصفح منع نافذة الطباعة. اسمح بالنوافذ المنبثقة.");
    return;
  }

  printWindow.document.open();
  printWindow.document.write(html);
  printWindow.document.close();
  printWindow.focus();

  const tryClose = () => {
    try {
      if (printWindow && !printWindow.closed) printWindow.close();
    } catch (e) {}
  };

  let printed = false;

  const handleAfterPrint = () => {
    if (!printed) return;
    setTimeout(() => tryClose(), 300);
  };

  printWindow.onafterprint = handleAfterPrint;

  try {
    if (printWindow.addEventListener) {
      printWindow.addEventListener("afterprint", handleAfterPrint);
    }
  } catch (e) {}

  const fallbackTimer = setTimeout(() => tryClose(), 15000);

  const safePrint = async () => {
    try {
      if (printWindow.__waitForAssets) {
        await printWindow.__waitForAssets();
      } else {
        await new Promise((r) => setTimeout(r, 600));
      }
    } catch (e) {}

    try {
      printed = true;
      printWindow.focus();
      printWindow.print();
    } catch (e) {
      console.error("❌ فشل أمر الطباعة", e);
    }
  };

  await safePrint();

  const pollInterval = setInterval(() => {
    if (!printWindow || printWindow.closed) {
      clearInterval(pollInterval);
      clearTimeout(fallbackTimer);
    }
  }, 500);
};

export const handleBrowserPrintInvoices = async (orderDetails, invoiceData, orderId) => {
  const html = await PrintInvoices(orderDetails, invoiceData, orderId);
  await openAndPrintHtml(html, "printWindow", "width=390,height=700");
};

export const handleBrowserPrintInvoicesReport = async (invoices = []) => {
  const html = await PrintInvoices({ invoices });
  await openAndPrintHtml(html, "printInvoicesReport", "width=390,height=700");
};